import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { MuiThemeProvider, withStyles, createMuiTheme } from '@material-ui/core/styles';
import {  Notification, Sidebar } from 'react-admin';
import MyMenu from './resources/menu';
import MyAppBar  from './resources/appbar';

const styles = theme => ({
  root: {
      display: 'flex',
      flexDirection: 'column',
      zIndex: 1,
      minHeight: '100vh',
      backgroundColor: theme.palette.background.default,
      position: 'relative',
  },
  appFrame: {
      display: 'flex',
      flexDirection: 'column',
  },
  contentWithSidebar: {
      display: 'flex',
      flexGrow: 1,
  },
  content: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 2,
      padding: '2em',
      overflow: 'hidden'
  },
  sidebar: {
    backgroundColor: '#fff',
    boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px'
  }
});

const theme = createMuiTheme({
  palette: {
    type: 'light',
  },
  typography: {
    useNextVariants: true,
  },
});

class Layout extends Component {
  render() {
    const { children, classes, dashboard, logout, title, open } = this.props;

    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          <div className={classes.appFrame}>
            <MyAppBar title={title} open={open} />
            <main className={classes.contentWithSidebar}>
              <Sidebar className={classes.sidebar}>
                <MyMenu logout={logout} hasDashboard={!!dashboard} />
              </Sidebar>
              <div className={classes.content}>
                  {children}
              </div>
            </main>
            <Notification />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  classes: PropTypes.object,
  dashboard: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  logout: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.string]),
  menu: PropTypes.element,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({ open: state.admin.ui.sidebarOpen });
export default connect(mapStateToProps)(withStyles(styles)(Layout));




// WEBPACK FOOTER //
// ./src/Layout.js